module.exports = __webpack_public_path__ + "img/help-office.8e6fc787.svg";